import { render } from "./UpdateAnagrafica.vue?vue&type=template&id=3a305608"
import script from "./UpdateAnagrafica.vue?vue&type=script&lang=js"
export * from "./UpdateAnagrafica.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__